import {
  ButtonSpecial,
  InputSearchAutocomplete,
  Logo,
} from "dab-component-lib";
import _ from "lodash";
import React from "react";
import { compose, graphql } from "react-apollo";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toggleMenu } from "../../../actions/index";
import I18n from "../../../I18n/I18n";
import {
  availableCurrencies,
  currentUserCart,
  currentUserQuery,
} from "../../../queries";
import {
  EDIT_PROFILE_URL,
  LOGIN_URL,
  LOGOUT_URL,
  SIGNUP_URL,
} from "../../../utils/constants";
import {
  GridColStyle,
  GridContainerStyle,
  GridRowStyle,
} from "../../../utils/style-utils";
import {
  ButtonWrapperStyle,
  LanguageSelectorStyled,
  LogoStyle,
  NavToggleStyle,
} from "./style";

import CartMenu from "../cartMenu/index";
import UserMenu from "../userMenu/index";

class PrimaryNavigation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showUserMenu: false,
      showCart: false,
      searchItem: "",
    };
  }

  componentDidMount() {
    const { currentUserQuery } = this.props;
    let localStorageShowPrices = localStorage.getItem("showPrices");
    if (localStorageShowPrices === null) {
      localStorage.setItem(
        "showPrices",
        !currentUserQuery.currentUserContext ||
          currentUserQuery.currentUserContext.uid === 0
          ? false
          : true
      );
    }
    let localStorageShowPricesIndex = localStorage.getItem("showPricesIndex");
    if (localStorageShowPricesIndex === null) {
      localStorage.setItem("showPricesIndex", 0);
    }
    let localStorageDefaultLanguage = localStorage.getItem("defaultLanguage");
    if (localStorageDefaultLanguage === null) {
      localStorage.setItem("defaultLanguage", "it");
    }
  }

  componentDidUpdate(prevProps) {
    const { currentUserQuery } = this.props;
    if (currentUserQuery !== prevProps.currentUserQuery) {
      localStorage.setItem(
        "showPrices",
        !currentUserQuery.currentUserContext ||
          currentUserQuery.currentUserContext.uid === 0
          ? false
          : true
      );
      localStorage.setItem("showPricesIndex", 0);
      localStorage.setItem("defaultLanguage", "it");
    }
  }

  //set state for menu visibility
  showMenu = (name) => {
    const { showUserMenu, showCart } = this.state;
    if (showUserMenu || showCart) {
      let array = ["showUserMenu", "showCart"];
      array.forEach(async (state) => {
        let obj = {};
        obj[state] = false;
        this.setState(obj);
      });
    }
    let obj = {};
    obj[name] = !this.state[name];
    this.setState(obj);
  };

  //handles cart button
  onCheckoutHandler = () => {
    const { history } = this.props;
    this.showMenu("showCart");
    history.push("/checkout");
  };

  //handles order button in user menu
  onOrders = () => {
    const { history } = this.props;
    this.showMenu("showUserMenu");
    history.push("/user-orders");
  };

  //handles user menu buttons behavior
  onUserMenuButtonClick = (link, language = null) => {
    this.showMenu("showUserMenu");
    const { currentUserCart } = this.props;
    localStorage.clear();
    currentUserCart.refetch();

    link =
      language && link.indexOf("%LANG") !== -1
        ? link.replace("%LANG", language)
        : link;
    window.location.href = link;
  };

  toggleMenuCategories = () => {
    const { openMenu, dispatch } = this.props;
    dispatch(toggleMenu(!openMenu.value));
  };

  searchHandler = ({ searchString }) => {
    const { history } = this.props;
    this.setState({ searchItem: "" }, () => {
      if (searchString.length > 0) {
        history.push({
          pathname: "/search-results",
          state: {
            name: searchString,
          },
        });
      }
    });
  };

  onLanguageSelectorCLick = () => {
    let otherLang = localStorage.getItem("language")
      ? localStorage.getItem("language") === "it"
        ? "en"
        : "it"
      : localStorage.getItem("defaultLanguage") === "it"
      ? "en"
      : "it";
    localStorage.setItem("language", otherLang);
    window.location.reload();
  };

  render() {
    let {
      history,
      currentUserQuery: { loading, error, currentUserContext },
      currentUserCart,
      availableCurrencies,
    } = this.props;
    const { showUserMenu, showCart, searchItem } = this.state;
    if (!loading && !error) {
      if (currentUserContext === null) {
        currentUserContext = { uid: "0" };
      }
      localStorage.setItem("currentUid", currentUserContext.uid.toString());

      if (
        currentUserContext &&
        currentUserContext.fieldRegion &&
        currentUserContext.fieldRegion.entity &&
        currentUserContext.fieldRegion.entity.entityLabel
      ) {
        const userRegion = currentUserContext.fieldRegion.entity.entityLabel;
        localStorage.setItem("userRegion", userRegion);
      }

      //currentUserContext.langcode ? localStorage.setItem('language', currentUserContext.langcode.value) : localStorage.setItem('language', 'it');
      currentUserCart.refetch({
        id: currentUserContext.uid.toString(),
      });
      if (!availableCurrencies.loading && !availableCurrencies.error) {
        let currency = _.find(
          availableCurrencies.nodeQuery.entities,
          (currency) => currency.title === "EUR"
        );
        localStorage.setItem("defaultCurrency", currency.nid);
      }
    }

    let otherLangText = localStorage.getItem("language")
      ? localStorage.getItem("language") === "it"
        ? "en"
        : "it"
      : localStorage.getItem("defaultLanguage") === "it"
      ? "en"
      : "it";

    if (error) {
      return <div>{error.message}</div>;
    }

    return (
      <header>
        {!loading &&
          !error &&
          !currentUserCart.loading &&
          !currentUserCart.error && (
            <GridContainerStyle>
              <GridRowStyle center>
                <GridColStyle logo>
                  <NavToggleStyle
                    href="#"
                    onClick={() => this.toggleMenuCategories()}
                  >
                    &#9776; <span>Menu</span>
                  </NavToggleStyle>
                  <LogoStyle onClick={() => history.push("/")}>
                    <Logo />
                  </LogoStyle>
                </GridColStyle>
                <GridColStyle search>
                  <div>
                    <InputSearchAutocomplete
                      expanded
                      onSearchClick={this.searchHandler}
                      placeholder={I18n.t("content.search")}
                      searchString={searchItem}
                    />
                  </div>
                </GridColStyle>
                <GridColStyle full>
                  <ButtonWrapperStyle small>
                    <ButtonSpecial
                      count={0}
                      disabled={false}
                      icon={
                        currentUserContext.uid === 0
                          ? "UserAddIcon"
                          : "UserIcon"
                      }
                      id="button_id"
                      onClick={() => {
                        this.showMenu("showUserMenu");
                      }}
                      onMouseEnter={function () {}}
                      onMouseLeave={function () {}}
                      skin="neutral"
                    />
                    {showUserMenu && (
                      <UserMenu
                        onClose={() => this.showMenu("showUserMenu")}
                        onOrders={this.onOrders}
                        onLogin={() => this.onUserMenuButtonClick(LOGIN_URL)}
                        onSignUp={(lang = null) =>
                          this.onUserMenuButtonClick(SIGNUP_URL, lang)
                        }
                        onLogout={() => this.onUserMenuButtonClick(LOGOUT_URL)}
                        onEditProfile={(lang = null) =>
                          this.onUserMenuButtonClick(EDIT_PROFILE_URL, lang)
                        }
                      />
                    )}
                    <ButtonSpecial
                      count={
                        currentUserCart.currentusercartGraphql1View.results
                          .length > 0
                          ? currentUserCart.currentusercartGraphql1View
                              .results[0].fieldLineItemsReference.length
                          : 0
                      }
                      disabled={false}
                      icon={"CartIcon"}
                      id="button_id"
                      onClick={() => this.showMenu("showCart")}
                      onMouseEnter={function () {}}
                      onMouseLeave={function () {}}
                      skin="secondary"
                    />
                    {showCart && (
                      <CartMenu
                        onCheckout={this.onCheckoutHandler}
                        onClose={() => this.showMenu("showCart")}
                      />
                    )}
                    <LanguageSelectorStyled>
                      <a onClick={this.onLanguageSelectorCLick}>
                        {otherLangText}
                      </a>
                    </LanguageSelectorStyled>
                  </ButtonWrapperStyle>
                </GridColStyle>
              </GridRowStyle>
            </GridContainerStyle>
          )}
      </header>
    );
  }
}

const mapStateToProps = ({ openMenu }) => {
  return {
    openMenu,
  };
};

export default connect(mapStateToProps)(
  compose(
    graphql(currentUserQuery, {
      name: "currentUserQuery",
    }),
    graphql(currentUserCart, {
      name: "currentUserCart",
      options: (props) => ({
        variables: {
          id: localStorage.getItem("currentUid"),
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(availableCurrencies, {
      name: "availableCurrencies",
      options: (props) => ({
        variables: {
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    })
  )(withRouter(PrimaryNavigation))
);



// WEBPACK FOOTER //
// ./src/components/common/primNav/index.js